import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ContentWrap from '../../../components/global/ContentWrap';
import { getAsset } from '../../../util/assets';
import Emoji from '../../../components/global/Emoji';

class WebGalleryFavoritePhotosNullState extends Component {
  static propTypes = {
    history: PropTypes.shape({
      length: PropTypes.number.isRequired,
      goBack: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired,
    }),
  };

  render() {
    return (
      <ContentWrap size="sm" mainClassName="no-box-shadow">
        <div className="text-center mt-5">
          <img
            src={getAsset('/waldo-icon.svg')}
            alt="Waldo Icon"
            className="mb-3"
            width="70px"
          />

          <p className="text-extra-bold text-dark">
            You don&rsquo;t have any favorited photos yet.
          </p>

          <p className="m-0">
            <Emoji label="star" emoji="⭐️" /> your favorites and then view,
            share, and download them here any time!
          </p>
        </div>
      </ContentWrap>
    );
  }
}

export default WebGalleryFavoritePhotosNullState;
